import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M18 2a4 4 0 0 0-3.919 4.803L9.04 9.4A4.001 4.001 0 0 0 2 12a4 4 0 0 0 7.04 2.6l5.041 2.597a4 4 0 0 0 1.09 3.631 4 4 0 1 0-.21-5.428l-5.042-2.597a4 4 0 0 0 0-1.606L14.96 8.6q.1.118.212.228A4 4 0 1 0 18 2",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as default
};
